import React, {Component} from 'react';
import Api from '../../services/Api';
import HelperGeneral from '../../helpers/HelperGeneral';
import HtmlParser from "react-html-parser";
import 'url-search-params-polyfill';
import {Link, withRouter} from "react-router-dom";
import {Spin} from 'antd';

let self = null;

class CategorySideBar extends Component {
    constructor(props) {
        super(props);
        self = this;

        this.state = {
            brandCategory: [],
            loading: true,
            active: '',
            categoryInfo: [
                {
                    slug: "daily/temel-bakim",
                    overlayColor: "#e2d0d8",
                    shortDescription: "Günlük Temel Bakım"
                },
                {
                    slug: "hydra/nemsiz-ciltler",
                    overlayColor: "#a5d7ef",
                    shortDescription: "Neme İhtiyacı Olan Ciltler"
                },
                {
                    slug: "sebum/akne-karsiti-bakim",
                    overlayColor: "#59d1bb",
                    shortDescription: "Karma, Yağlı ve Akne Eğilimli Ciltler"
                },
                {
                    slug: "sensitive/hassas-ciltler",
                    overlayColor: "#F3D8CB",
                    shortDescription: "Hassas Ciltler"
                },
                {
                    slug: "repair/onarici-bakim",
                    overlayColor: "#B7BADB",
                    shortDescription: "Onarım İhtiyacı Olan Ciltler"
                },
                {
                    slug: "sdcare/kepek-ve-pullanma-karsiti-bakim",
                    overlayColor: "#A4C8E1",
                    shortDescription: "Yağlı ve Hassas Ciltler"
                },
                {
                    slug: "adcare/kuru-cok-kuru-ve-atopiye-egilimli-ciltler",
                    overlayColor: "#A4C8E1",
                    shortDescription: "Kuru & Çok Kuru Atopiğe Eğilimli Ciltler"
                },
                {
                    slug: "uvdefence/gunesten-koruma",
                    overlayColor: "#FFCD00",
                    shortDescription: "Güneş Koruma"
                },
                {
                    slug: "kampanyali-urunlerimiz",
                    overlayColor: "#349baa",
                    shortDescription: "Kampanyalı Ürünlerimiz"
                }
            ]
        };

        this.itemRefs = [];
    }

    componentDidMount() {
        this.brandCategory();
    }

    brandCategory() {
        Api.getCategoryWithSubCategories().then(function (response) {
            let result = response?.data[0]?.sub_cats[0]?.sub_cats ?? [];
            self.setState({brandCategory: result}, () => {
                self.setState({loading: false});
            });
            if (self.props.setSideBarData) {
                self.props.setSideBarData(this.state.categoryInfo);
            }
        }.bind(this)).catch(function (e) {
            self.setState({loading: false});
            HelperGeneral.alert(e);
        });
    }

    checkClassName = (index) => {
        if (this.itemRefs[index]?.classList?.contains('active')) {
            this.itemRefs[index]?.classList?.remove('active');
        } else {
            this.itemRefs?.map((ref) => {
                if (ref.classList?.contains('active')) {
                    ref.classList?.remove('active');
                }
            })
            this.itemRefs[index].classList?.add('active');
        }
    };

    render() {
        const {brandCategory, loading, categoryInfo} = this.state;

        const categorySlug = self.props.productDetailSlug ?? this.props?.match?.params?.category_id + '/' + this.props?.match?.params?.sub_id;

        //ProductDetail
        let pageName2 = 'kategori';

        return (
            <Spin spinning={loading}>
                <aside className={"sidebar"}>
                    <style>
                        {
                            brandCategory?.length > 0 ? (
                                brandCategory?.map(function (v, i) {
                                    return HtmlParser(
                                        'li.catID_' + v?.slug.replace(/[^\w-]/g, "_") + ' > a:hover {background-color:' + categoryInfo?.find((data) => data?.slug === v?.slug)?.overlayColor + ' !important;} ' +
                                        'li.catID_' + v?.slug.replace(/[^\w-]/g, "_") + ' > a:before {background-color:' + categoryInfo?.find((data) => data?.slug === v?.slug)?.overlayColor + ' !important;}' +
                                        'li.catID_' + v?.slug.replace(/[^\w-]/g, "_") + ' ul.sub-menu li > a:hover{background-color:' + categoryInfo?.find((data) => data?.slug === v?.slug)?.overlayColor + ' !important;}' +
                                        'li.catID_' + v?.slug.replace(/[^\w-]/g, "_") + ' ul.sub-menu li.active > a{background-color:' + categoryInfo?.find((data) => data?.slug === v?.slug)?.overlayColor + ' !important;}'
                                    );
                                })
                            ) : (
                                ''
                            )
                        }
                    </style>
                    <div className={"widgets"}>
                        <div className={"widget products-menu"}>
                            <ul>
                                {
                                    brandCategory?.length > 0 && (
                                        brandCategory?.map(function (v, i) {
                                            return (
                                                <li
                                                    key={i}
                                                    ref={(ref) => (self.itemRefs[i] = ref)}
                                                    className={
                                                        v?.slug === categorySlug
                                                            ? 'sub active catID_' + v?.slug.replace(/[^\w-]/g, "_")
                                                            : 'sub degil2 catID_' + v?.slug.replace(/[^\w-]/g, "_")
                                                    }
                                                >
                                                    <Link
                                                        to={'/' + pageName2 + '/' + v?.slug}
                                                        onClick={() => {
                                                            self.checkClassName(i);
                                                            self.props?.onClose && self.props?.onClose();
                                                        }}
                                                        className="subcategory-link"   // optional, for styling instead of the <a>
                                                    >
                                                        <span className={"title"}>{v?.name?.split("/")[0].trim()}</span>
                                                        <span className={"desc"}>
                                                            {
                                                                categoryInfo?.find(
                                                                    (data) =>
                                                                        data?.slug.replace(/[^\w-]/g, "_") === v?.slug.replace(/[^\w-]/g, "_")
                                                                )?.shortDescription
                                                            }
                                                        </span>
                                                    </Link>
                                                </li>
                                            )
                                        })
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                </aside>
            </Spin>
        );
    }
}

export default withRouter(CategorySideBar);
